/**
 * @generated SignedSource<<bce77e8a7ddd8bfc871f2c0e799cc280>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFDFQuoteVariant_viewer$data = {
  readonly regionalInfo: ReadonlyArray<{
    readonly countryCode: string | null;
  } | null> | null;
  readonly " $fragmentType": "useFDFQuoteVariant_viewer";
};
export type useFDFQuoteVariant_viewer$key = {
  readonly " $data"?: useFDFQuoteVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFDFQuoteVariant_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFDFQuoteVariant_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RegionalInfo",
      "kind": "LinkedField",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "66e88c628686c1dc46710e9b298c6e8a";

export default node;
